export default "__VITE_ASSET__Pfiv8SoUfQMa_7dTVCKlpQ__"